// store/companySlice.ts
import { RootState } from "@/store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Company } from "@t/Company";
import { LeadSource } from "@t/LeadSource";
import { LeadType } from "@t/LeadType";
import { Office } from "@t/Office";
import { SelectOptionDto } from "@t/SelectOptionDto";
import { UserGet } from "@t/UserGet";
import { useSelector } from "react-redux";

export interface CompanyState {
    company?: Company;
    users: UserGet[];
    usersWithLeadsOptions: SelectOptionDto[];
    allUserOptions: SelectOptionDto[];
    activeUserOptions: SelectOptionDto[];
    offices: Office[];
    leadSources: LeadSource[];
    leadTypes: LeadType[];
}

const initialState: CompanyState = {
    company: undefined,
    users: [],
    usersWithLeadsOptions: [],
    allUserOptions: [],
    activeUserOptions: [],
    offices: [],
    leadSources: [],
    leadTypes: [],
};

const companyDataSlice = createSlice({
    name: "company",
    initialState,
    reducers: {
        setCompany: (s, a: PayloadAction<Company | undefined>) => {
            s.company = a.payload;
        },
        setUsers: (s, a: PayloadAction<UserGet[]>) => {
            s.users = a.payload;
        },
        setUsersWithLeadsOptions: (s, a: PayloadAction<SelectOptionDto[]>) => {
            s.usersWithLeadsOptions = a.payload;
        },
        setAllUserOptions: (s, a: PayloadAction<SelectOptionDto[]>) => {
            s.allUserOptions = a.payload;
        },
        setActiveUserOptions: (s, a: PayloadAction<SelectOptionDto[]>) => {
            s.activeUserOptions = a.payload;
        },
        setOffices: (s, a: PayloadAction<Office[]>) => {
            s.offices = a.payload;
        },
        setLeadSources: (s, a: PayloadAction<LeadSource[]>) => {
            s.leadSources = a.payload;
        },
        setLeadTypes: (s, a: PayloadAction<LeadType[]>) => {
            s.leadTypes = a.payload;
        },
        clearCompanyState: () => initialState,
    },
});

export const {
    setCompany,
    setUsers,
    setUsersWithLeadsOptions,
    setAllUserOptions,
    setActiveUserOptions,
    setOffices,
    setLeadSources,
    setLeadTypes,
    clearCompanyState,
} = companyDataSlice.actions;

export const useCompanyData = () => useSelector((state: RootState) => state.companyData);

export const companyDataReducer = companyDataSlice.reducer;
